import React, { useState, useEffect, useRef, useCallback } from 'react';
import PersonRow from './PersonRow';

const BATCH_SIZE = 15;

function PersonList({ persons, votes, handleVote, searchTerm, selectedCategory }) {
    const [visibleCount, setVisibleCount] = useState(BATCH_SIZE);
    const loaderRef = useRef(null);

    useEffect(() => {
        setVisibleCount(BATCH_SIZE);
    }, [searchTerm, selectedCategory]);

    const loadMore = useCallback(() => {
        setVisibleCount((prev) => Math.min(prev + BATCH_SIZE, persons.length));
    }, [persons.length]);

    useEffect(() => {
        const loader = loaderRef.current;
        if (!loader) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && visibleCount < persons.length) {
                    loadMore();
                }
            },
            { rootMargin: '200px' }
        );

        observer.observe(loader);
        return () => observer.disconnect();
    }, [visibleCount, persons.length, loadMore]);

    if (persons.length === 0) {
        return (
            <div className="empty-state">
                <div className="empty-icon">&#128269;</div>
                <h3>No results found</h3>
                <p>Try adjusting your search or filter criteria</p>
            </div>
        );
    }

    return (
        <div className="person-list">
            {persons.slice(0, visibleCount).map((person) => (
                <PersonRow
                    key={person.id}
                    person={person}
                    voteCount={votes[person.id]?.votes || 0}
                    handleVote={handleVote}
                />
            ))}
            {visibleCount < persons.length && (
                <div ref={loaderRef} className="infinite-scroll-loader">
                    <div className="loading-spinner"></div>
                </div>
            )}
        </div>
    );
}

export default PersonList;
